import { useState } from 'react';

export default function useProcessStepController(inicialStep, inicialControllers) {
  const [step, setStep] = useState(inicialStep);
  const [controllers, setControllers] = useState(inicialControllers ?? {});
  const [history, setHistory] = useState([]);

  const previousStep = () => {
    if (history.length) {
      setStep(history[history.length - 1]);
      setHistory(history.slice(0, (history.length - 1)));
    }
  };
  const goToStep = (newStep) => {
    setHistory([...history, step]);
    setStep(newStep);
  };

  const updateDataController = (controller, data) => setControllers({ ...controllers, [controller]: data });

  const updateMultipleDataControllers = (newControllers) => setControllers({ ...controllers, ...newControllers });

  return ({
    sharedStates: {
      step,
      controllers,
    },
    commands: {
      previousStep,
      goToStep,
      updateDataController,
      updateMultipleDataControllers
    },
  });
}
